import React from 'react';
import _ from 'lodash';

import SpotWorkersContext from '../../services/spotWorkers/SpotWorkersContext';

import Tippy from '../../components/ReactTippy';

import { Confirmation, Information } from '../modals/common/';

import { messageUtility } from '../../utilities/messageUtility';
import masterSlideLoader from '../../utilities/masterSlideLoader';
import {
  SORT_TYPE,
  WORKER_IMAGE_REGISTER_STATUS,
  WORKER_IMAGE_CCUS_SYNCED_STATUS,
  SPOT_WORKER_STATUS,
  SPOT_WORKER_RESIDENCE_TYPE,
  SPOT_WORKER_TAB,
  SPOT_WORKER_TYPE,
} from '../../utilities/constants';

import Styles from '../../styles/componentStyle/spotWorkers/spotWorkers.scss';
import { isNullOrUndefinedOrEmptyStr } from '../../utilities/stringUtil';

/**
 * 現場常駐社員・非常駐入退場者一覧 (顔写真)データテーブル
 * */
export const SpotWorkersTable = ({ spotWorkerType, isVisibleThumbnails }) => {
  const displayedTableTitles = data.tableTitles.filter(title => {
    return (
      title.name !== 'worker_type' ||
      spotWorkerType === SPOT_WORKER_RESIDENCE_TYPE.NON_RESIDENT
    );
  });
  // 画面表示
  return (
    <SpotWorkersContext.Consumer>
      {({
        state,
        changeSort,
        isUpdateStatusDialogEnabled,
        isIntegrationStartedDialogEnabled,
        closeDialog,
        handleUpdateStatusConfirmButtonClicked,
      }) => (
        <div
          className={`${
            Styles.spotWorkersTable
          } master-slide-view__body worker-type-${spotWorkerType.id}`}
        >
          <table className='table'>
            <thead className='table__header'>
              <tr className='table__label'>
                <th className='value-table value-table--table__label' />
                {displayedTableTitles.map((title, index) => (
                  <th
                    className={`value-table value-table--table__label ${
                      title.name
                    }`}
                    key={index}
                    onClick={() => {
                      if (title.doSort === true) {
                        changeSort(title.name);
                      }
                    }}
                  >
                    <div className='value-table__label'>
                      <span
                        className={`${
                          title.doSort !== true
                            ? 'value-table__label-no-sort-icon'
                            : 'value-table__label-with-sort-icon'
                        }`}
                      >
                        {title.label}
                        {state.searchForm.order === title.name &&
                          state.searchForm.sortType === SORT_TYPE.asc.id && (
                            <button className='btn-icon--xs--dark'>
                              <i className='i-sortaz i-1x' />
                            </button>
                          )}
                        {state.searchForm.order === title.name &&
                          state.searchForm.sortType === SORT_TYPE.desc.id && (
                            <button className='btn-icon--xs--dark'>
                              <i className='i-sortza i-1x' />
                            </button>
                          )}
                        {title.doSort === true &&
                          state.searchForm.order !== title.name && (
                            <button className='btn-icon--xs--dark btn-icon__sort btn-icon__sort--low-opacity'>
                              <i className='i-sortdefault i-1x' />
                            </button>
                          )}
                      </span>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className='table__body'>
              {state.spotWorkers.map(item => (
                <FixItems
                  worker={item}
                  key={item.field_spot_worker_id}
                  spotWorkerType={spotWorkerType}
                  isVisibleThumbnails={isVisibleThumbnails}
                />
              ))}
            </tbody>
          </table>

          {/* 顔写真登録の開始ダイアログ */}
          <Information
            visible={isIntegrationStartedDialogEnabled()}
            message={messageUtility.getMessage('I-002-011-01')}
            buttonText={messageUtility.getMessage('I-000-017')}
            onClose={() => closeDialog()}
            rootClassName='Styles.imageUploadDialog'
            multilineText={true}
          />

          {/* ステータス更新ダイアログ */}
          <Confirmation
            visible={isUpdateStatusDialogEnabled()}
            title={data.updateStatusDialog.title}
            confirmButtonText={data.updateStatusDialog.confirmButton}
            cancelButtonText={data.updateStatusDialog.cancelButton}
            message={<UpdateStatusDialog />}
            isNegative={true}
            onCancel={() => closeDialog()}
            onConfirm={() => handleUpdateStatusConfirmButtonClicked()}
            rootClassName={Styles.updateStatusDialog}
            negativeButtonClassName={'btn--effective'}
          />
        </div>
      )}
    </SpotWorkersContext.Consumer>
  );
};

/**
 * 現場常駐社員・非常駐入退場者一覧 (顔写真)データ表示
 * */
const FixItems = ({ worker, spotWorkerType, isVisibleThumbnails }) => {
  const getWorkerImage = () => {
    if (
      isVisibleThumbnails &&
      worker.worker_image_register_status ===
        WORKER_IMAGE_REGISTER_STATUS.register.id
    ) {
      return (
        <div className='table__item-thumbnail'>
          <div className='table__item-thumbnail__content'>
            <img src={worker.worker_thumbnail_image_url} />
          </div>
        </div>
      );
    }

    const status = _.find(
      WORKER_IMAGE_REGISTER_STATUS,
      item => worker.worker_image_register_status === item.id
    );

    return (
      <span key={status.id} className={status.className}>
        {_.get(status, 'name')}
      </span>
    );
  };
  // 画面表示
  return (
    <SpotWorkersContext.Consumer>
      {({ state, showStatusDialog, handleSpotWorkerSelected }) => (
        <tr className='table__item'>
          {/*/!*チェックボックス*!/*/}
          <td
            className='gate-list-value-table__name'
            onClick={event => event.stopPropagation()}
          >
            <label className='toggle-radius'>
              <input
                type='checkbox'
                name='single-checkbox'
                value={worker.id}
                checked={_.includes(state.selectedSpotWorkers, worker)}
                onChange={() => {
                  handleSpotWorkerSelected(worker);
                }}
              />
              <i className='i-square i-3x' aria-hidden='true' />
            </label>
          </td>
          {/*/!*氏名*!/*/}
          <td className='gate-list-value-table__name spot_worker_name'>
            <WithTooltip>{worker.fullname}</WithTooltip>
          </td>
          {/*/!*会社名*!/*/}
          {spotWorkerType === SPOT_WORKER_RESIDENCE_TYPE.NON_RESIDENT && (
            <td className='gate-list-value-table__name worker_type'>
              {worker.worker_type == 2 ? (
                <React.Fragment>
                  <WithTooltip>
                    {SPOT_WORKER_TYPE.TEMPORARY.name}
                    <br />({state.primeCompanyName})
                  </WithTooltip>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <WithTooltip>
                    {SPOT_WORKER_TYPE.GUEST.name}
                    {!isNullOrUndefinedOrEmptyStr(worker.company_name) && (
                      <React.Fragment>
                        <br />({worker.company_name})
                      </React.Fragment>
                    )}
                  </WithTooltip>
                </React.Fragment>
              )}
            </td>
          )}
          {/*/!*顔写真*!/*/}
          <td className='gate-list-value-table__name register_status'>
            {getWorkerImage()}
          </td>
          {/*/!*顔写真送信*!/*/}
          <td className='gate-list-value-table__name send_status'>
            {_.map(WORKER_IMAGE_CCUS_SYNCED_STATUS, item => {
              if (worker.worker_image_info.ccusSyncedStatus === item.id) {
                const content = <span key={item.id}>{item.name}</span>;
                if (worker.worker_image_info.allCcusSyncedStatuses.length > 0) {
                  const tooltipContent = worker.worker_image_info.allCcusSyncedStatuses.map(
                    (item, index) => <p key={index}>{item.formatted}</p>
                  );
                  return (
                    <Tippy
                      duration={10}
                      distance={24}
                      arrowType='sharp'
                      delay={[100, 0]}
                      placement='bottom'
                      followCursor={true}
                      html={
                        <div className={Styles.toopTip}>{tooltipContent}</div>
                      }
                    >
                      {content}
                    </Tippy>
                  );
                } else {
                  return content;
                }
              }
            })}
          </td>
          {/*/!*エラー状況*!/*/}
          <td className='gate-list-value-table__name has_error'>
            {worker.worker_image_info.allErrors.length > 0 ? (
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[100, 0]}
                placement='bottom'
                followCursor={true}
                html={
                  <div className={Styles.toopTip}>
                    {worker.worker_image_info.allErrors.map((item, index) => {
                      return <p key={index}>{item.formatted}</p>;
                    })}
                  </div>
                }
              >
                <p
                  className={
                    worker.worker_image_info.hasError ? 'error_message' : ''
                  }
                >
                  {worker.worker_image_info.errorMessage}
                </p>
              </Tippy>
            ) : (
              <p>ー</p>
            )}
          </td>
          {/*/!*ステータス*!/*/}
          <td className='gate-list-value-table__name blocked_on'>
            <WorkerStatusCell
              worker={worker}
              showStatusDialog={showStatusDialog}
            />
          </td>
          {/*/!*詳細*!/*/}
          <td className='gate-list-value-table__name detail'>
            <button
              className='btn--stay'
              onClick={() => {
                masterSlideLoader.show('SpotWorkerConfirm', {
                  state: {
                    id: `${SPOT_WORKER_TAB.BASIC_INFO.ID},${
                      worker.field_spot_worker_id
                    }`,
                  },
                });
              }}
            >
              {data.buttonTitle.confirmation}
            </button>
            <button
              className='btn--stay'
              onClick={() => {
                masterSlideLoader.show('SpotWorkerConfirm', {
                  state: {
                    id: `${SPOT_WORKER_TAB.FACE_IMAGE.ID},${
                      worker.field_spot_worker_id
                    }`,
                  },
                });
              }}
            >
              {data.buttonTitle.imageConfirmation}
            </button>
          </td>
        </tr>
      )}
    </SpotWorkersContext.Consumer>
  );
};

const WorkerStatusCell = ({ worker, showStatusDialog }) => {
  let workerStatus = SPOT_WORKER_STATUS.IN_OPERATION.id;
  if (worker.blocked_on !== null) {
    workerStatus = SPOT_WORKER_STATUS.SUSPENSION.id;
  }
  if (SPOT_WORKER_STATUS.IN_OPERATION.id === workerStatus) {
    return (
      <div
        className='status--mid--caution editable'
        onClick={e => {
          e.stopPropagation();
          showStatusDialog(worker);
        }}
      >
        {SPOT_WORKER_STATUS.IN_OPERATION.name}
        <i className='i-arrow-small-bottom--dark' />
      </div>
    );
  } else {
    return (
      <div
        className='status--mid editable'
        onClick={e => {
          e.stopPropagation();
          showStatusDialog(worker);
        }}
      >
        {SPOT_WORKER_STATUS.SUSPENSION.name}
        <i className='i-arrow-small-bottom--dark' />
      </div>
    );
  }
};

/**
 * ステータス更新ダイアログ
 * */
const UpdateStatusDialog = () => {
  return (
    <SpotWorkersContext.Consumer>
      {({ state, changeStatus }) => (
        <div className='status-change'>
          <div className='status-change-message'>
            {data.updateStatusDialog.message}
          </div>
          <div className='status-change-radio'>
            {_.map(SPOT_WORKER_STATUS, status => (
              <label>
                <input
                  type='radio'
                  name='worker_status'
                  value={status.id}
                  checked={
                    status.id == state.updateStatusDialog.selectedValue.id
                  }
                  onChange={() => changeStatus(status)}
                />
                <span>{status.name}</span>
              </label>
            ))}
          </div>
        </div>
      )}
    </SpotWorkersContext.Consumer>
  );
};

const WithTooltip = ({ children, className }) => (
  <Tippy
    duration={10}
    distance={24}
    arrowType='sharp'
    delay={[100, 0]}
    placement='bottom'
    followCursor={true}
    html={<div className={Styles.toopTip}>{children}</div>}
  >
    <p className={className}>{children}</p>
  </Tippy>
);

// 定数
const data = {
  tableTitles: [
    { name: 'spot_worker_name', label: '氏名', doSort: true },
    { name: 'worker_type', label: '入退場者種別', doSort: true },
    { name: 'register_status', label: '顔写真', doSort: true },
    { name: 'send_status', label: '顔写真送信', doSort: true },
    { name: 'has_error', label: 'エラー状況', doSort: true },
    { name: 'blocked_on', label: 'ステータス', doSort: true },
    { name: 'detail', label: '詳細', doSort: false },
  ],
  buttonTitle: {
    confirmation: '確認',
    imageConfirmation: '顔写真確認',
  },
  updateStatusDialog: {
    title: 'ステータスの変更',
    message:
      'ステータスを「停止中」にすると、現場への入退場ができなくなります。',
    confirmButton: '変更',
    cancelButton: '戻る',
  },
};



// WEBPACK FOOTER //
// ./src/components/tables/SpotWorkersTable.jsx